import { makeStyles } from '@material-ui/core/styles';

const useGlobalStyles = makeStyles(theme => ({
	'@global': {
		'.info-btn': {
			backgroundColor: theme.palette.info.main,
			color: '#fff',
			'&:hover': {
				backgroundColor: theme.palette.info.main
			}
		},
		'.danger-color-card': {
			borderLeft: 'solid 6px' + theme.palette.error.main,
			borderRight: 'solid 6px' + theme.palette.error.main
		},
		'.warning-color-card': {
			borderLeft: 'solid 6px' + theme.palette.warning.main,
			borderRight: 'solid 6px' + theme.palette.warning.main
		},
		'.secondary-color-card': {
			borderLeft: 'solid 6px' + theme.palette.secondary.main,
			borderRight: 'solid 6px' + theme.palette.secondary.main
		},
		'.danger-icon': {
			color: theme.palette.error.main
		},
		'.warning-icon': {
			color: theme.palette.warning.main
		},
		'.secondary-icon': {
			color: theme.palette.secondary.main
		},
		'.list-item': {
			display: 'flex',
			marginTop: '4px',
			marginBottom: '4px'
		},
		'.no-padding': {
			padding: '0 !important'
		},
		'.start': {
			alignItems: 'flex-start'
		},
		'.nomargin': {
			margin: '0 !important'
		}
	}
}));

export default useGlobalStyles;